import React from "react";
import {
  Modal,
  View,
  TouchableOpacity,
  StyleSheet,
  KeyboardAvoidingView,
  Platform,
  ScrollView} from "react-native";
import PersonalDetailsStyle from "../screens/Profile/PersonalDetails/PersonalDetailsStyle";
import { fonts } from "../styles/theme";
import AppText from "./AppText";
import AppTextInput from "./AppTextInput";

interface EmailPromptModalProps {
  visible: boolean;
  initialEmail: string;
  initialFirstName?: string;
  initialLastName?: string;
  onCancel: () => void;
  onSubmit: (data: {
    firstName: string;
    lastName: string;
  }) => void;
}

const EmailPromptModal: React.FC<EmailPromptModalProps> = ({
  visible,
  initialFirstName = "",
  initialLastName = "",
  onCancel,
  onSubmit}) => {
  const [firstName, setFirstName] = React.useState(initialFirstName);
  const [lastName, setLastName] = React.useState(initialLastName);

  const [touched, setTouched] = React.useState({
    firstName: false,
    lastName: false});

  React.useEffect(() => {
    setFirstName(initialFirstName);
    setLastName(initialLastName);
  }, [initialFirstName, initialLastName]);

  const errors = {
    firstName:
      touched.firstName && firstName.trim() === ""
        ? "First name is required"
        : "",
    lastName:
      touched.lastName && lastName.trim() === "" ? "Last name is required" : ""};

  const formValid =
    firstName.trim() !== "" &&
    lastName.trim() !== "" 
  

  const handleSubmit = () => {
    if (!formValid) return;
    onSubmit({
      firstName,
      lastName});
  };

  return (
    <Modal visible={visible} transparent animationType="fade">
       <KeyboardAvoidingView
        behavior={Platform.OS === "ios" ? "padding" : "height"}
        style={{ flex: 1 }}
      >
      <View style={styles.overlay}>
        <View style={styles.modal}>
    
              <AppText style={styles.title}>Required Information</AppText>
              <AppText style={styles.subtitle}>
                First Name and Last Name are required to proceed
              </AppText>

              <AppText style={PersonalDetailsStyle.label}>
                First Name <AppText style={{ color: "black" }}>*</AppText>
              </AppText>
              <AppTextInput
                placeholder="First Name"
                style={[styles.input, errors.firstName && styles.inputError]}
                value={firstName}
                onChangeText={setFirstName}
                onBlur={() => setTouched({ ...touched, firstName: true })}
              />
              {errors.firstName ? (
                <AppText style={styles.errorText}>{errors.firstName}</AppText>
              ) : null}

              <AppText style={PersonalDetailsStyle.label}>
                Last Name <AppText style={{ color: "black" }}>*</AppText>
              </AppText>
              <AppTextInput
                placeholder="Last Name"
                style={[styles.input, errors.lastName && styles.inputError]}
                value={lastName}
                onChangeText={setLastName}
                onBlur={() => setTouched({ ...touched, lastName: true })}
              />
              {errors.lastName ? (
                <AppText style={styles.errorText}>{errors.lastName}</AppText>
              ) : null}


              <View style={styles.buttons}>
                <TouchableOpacity style={styles.cancel} onPress={onCancel}>
                  <AppText style={styles.cancelText}>Cancel</AppText>
                </TouchableOpacity>

                <TouchableOpacity
                  style={[styles.submit, !formValid && { opacity: 0.5 }]}
                  disabled={!formValid}
                  onPress={handleSubmit}
                >
                  <AppText style={styles.submitText}>Submit</AppText>
                </TouchableOpacity>
              </View>
        </View>
      </View>
      </KeyboardAvoidingView>
    </Modal>
  );
};

const styles = StyleSheet.create({
  overlay: {
    flex: 1,
    backgroundColor: "rgba(0,0,0,0.4)",
    justifyContent: "center",
    alignItems: "center"},
  modal: {
    width: "85%",
    backgroundColor: "#fff",
    borderRadius: 14,
    padding: 20,
    elevation: 0},
  title: {
    fontSize: 20,
    //fontWeight: "700",
    marginBottom: 10,
    color: "#1A1A1A",
    fontFamily: fonts.regular
  },
  subtitle: {
    fontSize: 16,
    lineHeight: 22,
    color: "#444",
    marginBottom: 24,
    fontFamily: fonts.regular
  },
  input: {
    height: 45,
    borderWidth: 1,
    borderRadius: 15,
    paddingHorizontal: 12,
    fontSize: 14,
    color: "#343434",
    marginBottom: 6,
    //fontWeight: "600",
    borderColor: "#CBCBCB",
    fontFamily: fonts.regular
  },
  inputError: {
    borderColor: "red"},
  errorText: {
    color: "red",
    fontSize: 12,
    marginBottom: 8,
    marginTop: -3,
    fontFamily: fonts.regular
  },
  buttons: {
    flexDirection: "row",
    justifyContent: "flex-end",
    alignItems: "center",
    marginTop: 10},
  cancel: {
    marginRight: 15},
  cancelText: {
    fontSize: 16,
    color: "#999",
    fontFamily: fonts.medium
  },
  submit: {
    backgroundColor: "#007AFF",
    paddingVertical: 8,
    paddingHorizontal: 16,
    borderRadius: 8},
  submitText: {
    color: "#fff",
    fontSize: 16,
    fontFamily: fonts.medium
  }});

export default EmailPromptModal;
